export const industryReportsSidebarLinks = [
    {
        title: "Overview",
        route: "overview",
    },
    {
        title: "Executive Summary",
        route: "executive-summary",
    },
    {
        title: "Competitive Landscape",
        route: "competitive-landscape",
    },
    {
        title: "Operating Conditions",
        route: "operating-conditions",
    },
    {
        title: "Key Stats",
        route: "key-stats",
    },
    {
        title: "Industry Outlook",
        route: "industry-outlook",
    },
    {
        title: "Key Trends",
        route: "key-trends",
    },
    {
        title: "Key Success Factors",
        route: "key-success-factors",
    },
    {
        title: "Major Companies",
        route: "major-companies",
    },
    {
        title: "SWOT Analysis",
        route: "swot-analysis",
    },
    {
        title: "PESTLE Analysis",
        route: "pestle-analysis",
    },
    {
        title: "Supply Chain",
        route: "supply-chain",
    },
];
